import { render, staticRenderFns } from "./BaseCategoryPicker.vue?vue&type=template&id=1937cca5"
import script from "./BaseCategoryPicker.vue?vue&type=script&lang=js"
export * from "./BaseCategoryPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports